/* import __COLOCATED_TEMPLATE__ from './item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface PoWorkbenchPrioritySelectItemSignature {
  Args: {
    color: unknown;
    icon: unknown;
    minimized: unknown;
    text: unknown;
  };
}

const PoWorkbenchPrioritySelectItemComponent =
  templateOnlyComponent<PoWorkbenchPrioritySelectItemSignature>();

export default PoWorkbenchPrioritySelectItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'PoWorkbench::PrioritySelect::Item': typeof PoWorkbenchPrioritySelectItemComponent;
    'po-workbench/priority-select/item': typeof PoWorkbenchPrioritySelectItemComponent;
  }
}
